import {
 Outlet
} from 'react-router-dom';

const PageBuilderPage: React.FC = () => {
    return (
        <Outlet />
    );
};

export default PageBuilderPage;
